var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMenuAnswerNotificationsBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.204 2.5-7.3 7.664L14.7 21.5l7.3-7.664L11.204 2.5Zm7.615 10.188-5.141-1.45-1.381-5.398 6.522 6.848ZM10.93 4.969l1.763 6.892a.57.57 0 0 0 .39.411l6.565 1.85-4.948 5.196-8.718-9.154L10.93 4.97Zm.274 14.28c0 .425-.33.772-.736.772H4.945c-.405 0-.735-.347-.735-.772 0-.426.33-.772.735-.772h5.523c.406 0 .736.346.736.772Zm-8.469-2.32h4.048c.405 0 .735-.347.735-.773 0-.425-.33-.772-.735-.772H2.735c-.405 0-.735.347-.735.772 0 .426.33.772.735.772Z",
    fill: "#660099"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuAnswerNotificationsBlue);
export default __webpack_public_path__ + "static/media/ic-menu-answer-notifications-blue.aaa660b6717a4e31a2fa44f261b4703c.svg";
export { ForwardRef as ReactComponent };